<div class="section-content">
  <tgrid-coverage-map-widget />
</div>
<div class="section-content">
  <tgrid-coverage-table-widget />
</div>
<div class="section-content">
  <tgrid-coverage-overview-widget />
</div>